import React, {useContext, useEffect, useState } from "react";
import { Row, Col, Pagination, Offcanvas, Card, Form } from 'react-bootstrap'
import { CiCircleCheck } from 'react-icons/ci'
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { formatDateTime,capitalizeFirstLetter } from "../../utils/Helper";
import { ToastContainer, toast } from "react-toastify";
import useMenuPermissions from "../../components/CustomHook/custompermission";

const TargetDetails = () => {
    const { id } = useParams();
    const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
    const authToken = process.env.REACT_APP_authToken;
    const { accessToken, logout } = useContext(UserContext);
    const headers = {
      "auth-token": authToken,
      authorization: accessToken,
    };
      const navigate = useNavigate();
      const [details ,setDetails] = useState("")
      const permissionscontext = useMenuPermissions("/admin/target-achievement");

          useEffect(()=>{
          fetchDetails()
          },[id])
      
          const fetchDetails = async () => {
              try {
                const response = await APIServices.get(
                  `/admin/target/details/${id}`,
                  headers
                );
                if (response?.status === 200) {
                  const data1 = response?.data?.details || [];
                  setDetails(data1);
                  } else if(response?.status === 401){
                  logout();
                  navigate("/");
                 }else {
                  setDetails([]);
                }
              } catch (error) {
                console.error("Error fetching data:", error);
                setDetails([]);
              }
            };
            const handleStatusChange = async (it) => {
                const newStatus = it.status === "Active" ? "Inactive" : "Active";
                try {
                    const payload = { id: it.id, status: newStatus };
                    const res = await APIServices.post(
                    `/admin/target/status_update`,
                    payload,
                    headers
                    );
                    if (res?.data?.status === true) {
                    showToast(res?.data?.message || "Success", "success");
                    fetchDetails()
                    } else {
                    showToast(res?.data?.message || "Something went wrong.", "error");
                    }
                } catch (error) {
                    console.error("Error updating status:", error);
                    showToast("Error updating status", "error");
                }
                }; 
         const showToast = (message, type) => {
                toast(message, {
                  position: "top-right",
                  autoClose: 2000,
                  type,
                  hideProgressBar: false,
                  closeOnClick: true,
                });
              };
    return (
        <>
            <div className='channel_details_inner manager_details_sec'>
                <h2 className='font_blue_18 font-600 mb-3'>Target Details</h2>

                <div className="channel_details ">
                    <div className='cd_header'>
                        <Row className='align-items-center'>
                            <Col md={8}>
                                <div class="ch_name d-flex align-items-center">
                                    {
                                      details?.profile_pic ?
                                        <img
                                          src={details?.profile_pic}
                                          className="img-fluid me-2 table_user"
                                          alt={details?.fullname}
                                          onError={(e) => (e.target.src = "/images/placeholder-img.jpg")}
                                        />
                                        :
                                        <img src="/images/placeholder-img.jpg"
                                          className='img-fluid me-2 table_user'
                                          alt="default img"
                                        />}
                                    <p className='font_blue_18 font-500 textTransform'>{details?.fullname}</p>
                                </div>
                            </Col>
                            <Col md={4}>
                                <ul className="d-flex align-items-center justify-content-end gap-2">
                                    {/* <li><img src="images/trash.svg" className="img-fluid trash" alt="trash" /></li> */}
                                    <li className={details.achieved ? "disabled" : ""}
                                    style={{
                                      pointerEvents: details.achieved
                                        ? "none"
                                        : "auto",
                                      opacity: details.achieved ? 0.5 : 1,
                                    }}> 
                                    <button
                                      disabled={!permissionscontext.edit}
                                      style={{
                                        border: "none",
                                        background: "transparent",
                                        padding: 0,
                                        cursor: !permissionscontext.edit
                                          ? "not-allowed"
                                          : "pointer",
                                        opacity: !permissionscontext.edit
                                          ? 0.5
                                          : 1,
                                      }}
                                      onClick={() => navigate(`/admin/update-targets/${details.id}`,{
                                        state: { row:details },
                                        })}
                                    >
                                    <img src="/images/Pen.svg" className="img-fluid pen" alt="pen"
                                    />
                                    </button>    
                                        </li>
                                </ul>
                            </Col>
                        </Row>
                    </div>

                    <div className='cd_body mt-4'>
                        <Row className='all_details'>
                            <Col md={4} lg={4}>
                                <div>
                                    <h4 className='font_blue_16 font-500 mb-2'>Created Date</h4>
                                    {/* <p className='font_blue_16 '>06 Feb 2025 at 12:30 PM</p> */}
                                      <p className='font_blue_16 '>{formatDateTime(details.created)}</p>
                                </div>
                            </Col>
                            <Col md={4} lg={4}>
                                <div>
                                    <h4 className='font_blue_16 font-500 mb-2'>Phone No</h4>
                                    {/* <p className='font_blue_16 '>(+91) 98746543210</p> */}
                                    <p className='font_blue_16 '>({details?.country_code}) {details?.mobile}</p>

                                </div>
                            </Col>
                            <Col md={4} lg={4}>
                                <div>
                                    <h4 className='font_blue_16 font-500 mb-2'>Email ID</h4>
                                    {/* <p className='font_blue_16 '>kenzi.lawson@example.com</p> */}
                                    <p className='font_blue_16 '>{details?.email}</p>

                                </div>
                            </Col>
                            <Col md={4} lg={4}>
                                <div>
                                <h4 className="font_blue_16 font-500 mb-2">Target Month</h4>
                                <p className="font_blue_16">
                                  {details?.month
                                    ? [
                                        "January", "February", "March", "April", "May", "June",
                                        "July", "August", "September", "October", "November", "December"
                                      ][details.month - 1]
                                    : "_"}
                                </p>

                                </div>
                            </Col>
                            <Col md={4} lg={4}>
                                <div>
                                    <h4 className='font_blue_16 font-500 mb-2'>Target Year</h4>
                                    <p className='font_blue_16 '>{details?.year}</p>
                                </div>
                            </Col>
                            <Col md={4} lg={4}>
                                <div>
                                    <h4 className='font_blue_16 font-500 mb-2'>Status</h4>
                                    <p className='font_blue_16 d-flex align-items-center'>{details?.status}{" "}   
                                      <Form className="Switch_toggle ms-2 position-relative">
                                        <input type="checkbox" id={`switch-${details.id}`} 
                                        checked={details.status === "Active"}
                                        onClick={() => handleStatusChange(details)}
                                        disabled={!permissionscontext.edit}
                                        />
                                        <label for="switch" className="position-absolute"
                                        htmlFor={`switch-${details.id}`}
                                        >Toggle</label>
                                       </Form>
                                    </p>
                                </div>
                            </Col>
                            <Col md={4} lg={4}>
                                <div>
                                    <h4 className='font_blue_16 font-500 mb-2'>Traget</h4>
                                    {/* <p className='font_blue_16 round_border'>12</p> */}
                                    <p className='font_blue_16 round_border'>{details?.target}</p>
                                </div>
                            </Col>
                            <Col md={4} lg={4}>
                                <div>
                                    <h4 className='font_blue_16 font-500 mb-2'>Achievement</h4>
                                    {/* <p className='font_blue_16 round_border'>12</p> */}
                                    <p className='font_blue_16 round_border'>{details?.achieved}</p>

                                </div>
                            </Col>
                            <Col md={12} lg={12}>
                                <div>
                                    <h4 className='font_blue_16 font-500 mb-2 '>Products</h4>
                                    {/* <p className='font_blue_16 '>PMS Strategies (Portfolio Management Services)</p> */}
                                    <p className='font_blue_16'>{capitalizeFirstLetter(details?.product_name)}</p>

                                </div>
                            </Col>
                            
                            <Col md={12} lg={12}>
                                <div>
                                    <h4 className='font_blue_16 font-500 mb-2'>Details</h4>
                                    
                                    <p className='font_blue_16 '>{details?.description}</p>
                            
                                </div>
                            </Col>

                        </Row>


                    </div>
                </div>

            </div>
                        <ToastContainer />
            
        </>
    )
}

export default TargetDetails